import React from 'react';
import loadable from '@loadable/component';
import Loading from './Loading';


export default loadable(
  () => import(/* webpackChunkName: "navigation" */ './Loadable'),
  {
    fallback: <Loading />,
  },
);
